import React, { useEffect, useState } from 'react';
import api from '../api';
import './PageTable.css';

function Partners() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [form, setForm] = useState({ name: '', logo_url: '', website_url: '', sort_order: 0 });

  const fetchPartners = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin-partners/all');
      setPartners(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPartners();
  }, []);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('photo', file);
      const res = await api.post('/admin-upload/image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setForm((f) => ({ ...f, logo_url: res.data.url }));
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal upload logo');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const openCreate = () => {
    setForm({ name: '', logo_url: '', website_url: '', sort_order: 0 });
    setModal({});
  };

  const openEdit = (item) => {
    setForm({
      name: item.name,
      logo_url: item.logo_url || '',
      website_url: item.website_url || '',
      sort_order: item.sort_order || 0,
    });
    setModal(item);
  };

  const submitForm = async (e) => {
    e.preventDefault();
    try {
      if (modal.id) {
        await api.put(`/admin-partners/${modal.id}`, form);
      } else {
        await api.post('/admin-partners', form);
      }
      setModal(null);
      await fetchPartners();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menyimpan partner');
    }
  };

  const deletePartner = async (id) => {
    if (!window.confirm('Hapus partner ini?')) return;
    try {
      await api.delete(`/admin-partners/${id}`);
      await fetchPartners();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menghapus partner');
    }
  };

  return (
    <div>
      <div className="page-header-row">
        <h1 className="page-title" style={{ marginBottom: 0 }}>Partner / Sponsor</h1>
        <button className="btn-primary" onClick={openCreate}>+ Tambah Partner</button>
      </div>
      {loading ? (
        <p>Memuat...</p>
      ) : (
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Logo</th>
                <th>Nama</th>
                <th>Urutan</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {partners.map((p) => (
                <tr key={p.id}>
                  <td>
                    <div style={{ width: 60, height: 30, background: '#303034', borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {p.logo_url && <img src={p.logo_url} alt={p.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} onError={(e) => { e.target.style.display = 'none'; }} />}
                    </div>
                  </td>
                  <td>{p.name}</td>
                  <td>{p.sort_order}</td>
                  <td>
                    <div className="action-buttons">
                      <button className="btn-edit" onClick={() => openEdit(p)}>Edit</button>
                      <button className="btn-delete" onClick={() => deletePartner(p.id)}>Hapus</button>
                    </div>
                  </td>
                </tr>
              ))}
              {partners.length === 0 && (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', color: '#888' }}>
                    Belum ada partner
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      {modal && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <form className="modal-box" onClick={(e) => e.stopPropagation()} onSubmit={submitForm}>
            <h2>{modal.id ? 'Edit Partner' : 'Tambah Partner Baru'}</h2>
            <input
              type="text"
              placeholder="Nama partner/brand"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              required
            />
            <label style={{ display: 'block', fontSize: 12, color: '#888', marginTop: 8 }}>URL Logo</label>
            <input
              type="url"
              placeholder="URL logo (atau upload dari perangkat di bawah)"
              value={form.logo_url}
              onChange={(e) => setForm({ ...form, logo_url: e.target.value })}
            />
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6 }}>
              <label style={{ display: 'inline-block', fontSize: 13, color: '#C9A66B', border: '1px solid #C9A66B', padding: '6px 14px', borderRadius: 6, cursor: 'pointer' }}>
                {uploading ? 'Mengupload...' : '📁 Upload dari Perangkat'}
                <input type="file" accept="image/jpeg,image/png,image/webp" onChange={handleFileUpload} disabled={uploading} style={{ display: 'none' }} />
              </label>
              {form.logo_url && (
                <div style={{ width: 40, height: 40, borderRadius: 4, overflow: 'hidden', background: '#303034' }}>
                  <img src={form.logo_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} onError={(e) => { e.target.style.display = 'none'; }} />
                </div>
              )}
            </div>

            <label style={{ display: 'block', fontSize: 12, color: '#888', marginTop: 12 }}>URL Website (opsional, biar logo bisa diklik)</label>
            <input
              type="url"
              placeholder="https://..."
              value={form.website_url}
              onChange={(e) => setForm({ ...form, website_url: e.target.value })}
            />

            <label style={{ display: 'block', fontSize: 12, color: '#888', marginTop: 12 }}>Urutan Tampil (angka kecil = tampil duluan)</label>
            <input
              type="number"
              value={form.sort_order}
              onChange={(e) => setForm({ ...form, sort_order: e.target.value })}
            />
            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={() => setModal(null)}>Batal</button>
              <button type="submit" className="btn-primary">Simpan</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

export default Partners;
